import ListSearch from 'Components/ListSearch'
import StyledFormControlLabel from 'Components/StyledFormControlLabel'
import { FormControl, FormLabel, LinearProgress, Radio, RadioGroup } from '@mui/material'
import Box from '@mui/material/Box'
import type React from 'react'
import type { FC } from 'react'
import { t } from 'ttag'

const SearchByField: FC<{
  searchText: string
  handleSearchTextChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleSearch: () => void
  searchLabelText: string
  searchHelperText: string
  searchField: string
  isSearchFieldChoicesLoading: boolean
  searchFieldChoices: string[][]
  handleSearchFieldChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}> = ({
  searchText,
  handleSearchTextChange,
  handleSearch,
  searchLabelText,
  searchHelperText,
  searchField,
  isSearchFieldChoicesLoading,
  searchFieldChoices,
  handleSearchFieldChange
}) => {
  return (
    <Box>
      <ListSearch
        searchText={searchText}
        handleSearchTextChange={handleSearchTextChange}
        handleSearch={handleSearch}
        placeholder={searchLabelText}
        helperText={searchHelperText}
      />
      <Box sx={{ mt: 1 }}>
        {isSearchFieldChoicesLoading ? (
          <Box>
            <LinearProgress />
          </Box>
        ) : (
          <FormControl>
            <>
              <FormLabel sx={{ fontSize: 14 }} id="search-field-radio-buttons-group-label">
                {t`Search for a field`}:
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="search-field-radio-buttons-group-label"
                name="row-radio-buttons-group"
                sx={{ fontSize: 14 }}
                value={searchField}
                onChange={handleSearchFieldChange}
              >
                {searchFieldChoices.map(option => (
                  <StyledFormControlLabel
                    key={option[0]}
                    value={option[0]}
                    control={<Radio size="small" />}
                    label={option[1]}
                  />
                ))}
              </RadioGroup>
            </>
          </FormControl>
        )}
      </Box>
    </Box>
  )
}

export default SearchByField
